import { ComponentParams, ComponentRendering, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { Anchor } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

interface C03HeadlineCTAProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: Fields;
}

interface Fields {
  CTA?: LinkField;
}

export const Default = (props?: C03HeadlineCTAProps): JSX.Element => {
  const id = props?.params?.RenderingIdentifier;
  const { renderLink } = useConditionalRendering();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <Anchor id={id} variant="solid1" size="medium" data-component={marketingRenderingName}>
      {renderLink(props?.fields?.CTA)}
    </Anchor>
  );
};
